// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productSelect":"productSelect_RZCIw"};